module.exports = __webpack_public_path__ + "img/orange_044.9d74dfff.png";